
Checkout.Cart.Shipping = function(checkout, cart) {
	var shipping = this;

	this.total = 0;
	this.originalShippingRetail = 0;

	this.country =
	this.zip =
    this.city =
	this.quoteRequest =
	this.$disabledMsg =
	this.errorMsg =
		false;

	this.zipRequired = true;

	this.$wrap = $('#cart-shipping-wrap');
	this.$error = $('#cart-shipping-error');
	this.$errorMsg = this.$error.find('.msg-text');
	this.$disabledOverlays = this.$wrap.find('.disabled-overlay');

	this.$weightWrap = $('#cart-weight-wrap');
	this.$weight = $('#cart-weight');
	this.$country = $('#cart-country');
	this.$zip = $('#cart-zip');
    this.$city = $('#shipping_city');

	this.init = function() { 
		var country = checkout.session.get('shipping.country'),
			zip = checkout.session.get('shipping.zip'),
            city = checkout.session.get('shipping.city'),
			billZip = checkout.session.get('billing.zip'),
			copyBilling = Boolean(checkout.session.get('copy_billing'));

		if (country)
			shipping.$country.val(country);

		if (zip) {
			if (copyBilling && billZip) { // if copyBilling use billing zip else shipping zip
				shipping.$zip.val(billZip);
				$('#billing_zip').attr('disabled', 'disabled'); // checkout.billship.$billing.zip is undefined???
			} else {
				shipping.$zip.val(zip);
				$('#billing_zip').removeAttr('disabled');
			}
		}

        if( city ) shipping.$city.val( city );
		
		if (checkout.billship) {
			checkout.billship.checkMatchingZipCode();
		}

		// if (checkout.session.get('PayPalConfirmed'))
		//	shipping.disable(true);

		shipping.listen();
	};

	this.listen = function() {

		shipping.$country
			.change(function() {
				shipping.$zip.val('');
				shipping.calc(false, true);
			})
			.focus(function() {
				shipping.removeFieldError(shipping.$country);
			});

		shipping.$zip
			.bind('input propertychange', function() {
				checkout.delayChange(shipping.$zip, 1000, function() {
					shipping.calc(false, true);
				});
			})
			.focus(function() {
				shipping.removeFieldError(shipping.$zip);
			});

        shipping.$city.bind( "input propertychange", function() {
            if( shipping.$country.val() != "US" ) {
                checkout.delayChange( shipping.$city, 1000, function() {
                    shipping.calc( false, true );
                } );
            }
        } );

		shipping.$wrap.click(function(e) {

			if (
				!shipping.$disabledMsg
				|| typeof shipping.$disabledMsg === 'boolean'
			)
				return;

			var	$target = $(e.target || e.srcElement),
				targetTagName = $target.prop('tagName').toUpperCase();

			if (
				$target.hasClass('disabled-overlay')
				|| targetTagName == 'INPUT'
				|| targetTagName == 'SELECT'
				|| targetTagName == 'LABEL'
			)
				shipping.error(shipping.$disabledMsg.clone(true));

		});
	};

	this.validateInput = function() {

		if (
			!Object.keys(cart.items).length
			|| !shipping.country
		)
			return false;

		if (!shipping.zipRequired)
			return true;

		if (
			!shipping.zip
			|| shipping.zip.length < 3
		)
			return false;

		return true;
	}

	this.calc = async function(force, destChanged, keepShippingSelection) {
		var $countryOption = shipping.$country.find('option:selected'),
			country = $countryOption.val() ? $countryOption.val().trim() : "", //  TODO: BCY, come back and address later
			zip = shipping.$zip.val() ? shipping.$zip.val().replace(/^\s/g, '').replace(/\s$/g, '').replace(/\s\s+/g, ' ') : shipping.$zip.val(), //  TODO: BCY, come back and address later
			city = shipping.$city.val(); 	
/*
			if(country == "US"){
				isDomestic = true;
				$("html").removeClass("intntl");
				$("#shipping-service-desc").hide();
			}
			else{
				isDomestic =  false;
				$("html").addClass("intntl");
				$("#shipping-service-desc").show();
			}
*/
		// no change
		if (
			!force
			&& country == shipping.country
			&& zip == shipping.zip
            && city == shipping.city
		)
			return cart.toggleStepControls();

		if (shipping.quoteRequest)
			shipping.quoteRequest.abort();

		shipping.country = country;
		shipping.zip = zip;
		shipping.zipRequired = Boolean(parseInt($countryOption.attr('data-ziprequired')));
        shipping.city = city;

		// no cart contents to quote on
		if (!shipping.validateInput()) {

			shipping.total = 0;
			checkout.shippingServiceGroupID = false;
			cart.totals.update('cart');

			shipping.error(false);

			cart.toggleStepControls();

			return;
		}

		// Save this data in session
		checkout.session.set({
			'shipping': {
				'country': shipping.country,
				'zip': shipping.zip
			}
		});


		cart.totals.loading('Calculating Shipping');

		if (!keepShippingSelection) {
			checkout.shippingServiceGroupID = false;
			checkout.shippingServiceCode = false;
		}

		checkout.shippingServiceGroupRates = {};
		checkout.shippingRates = {};

		shipping.error(false);

		// Hide step-control buttons while shipping is quoting
		cart.toggleStepControls(false);

		var wantQuoteType = (
			checkout.session.get('shippingDisplayType')
			|| 'auto'
		);

		shipping.quoteRequest = checkout.remote.call({
			'url': checkout.config.shipQuoteEndpoint,
			'data': {
				'wantQuoteType': wantQuoteType,
				'shipping_country': shipping.country,
				'shipping_zip': shipping.zip,
                'shipping_city': shipping.city,
				'country_name': shipping.getCountryName(),
				'shipETA': checkout.cart.shipETA,
			}
		})
			.done(function(response) {
				shipping.handleShipQuoteResponse(response, destChanged)
			})
			.fail(function(request) {
				var errorMsg = checkout.remote.getErrorMsg(request);
				
				if (errorMsg)
					shipping.error('Shipping Quote Failed: '+errorMsg);
					
			})
			.always(function() {
				shipping.quoteRequest = false;
				cart.toggleStepControls();
			});

        try { await shipping.quoteRequest }
        catch ( e ) { console.warn( "failed ship quote", e ) }
	}
	
	this.handleShipQuoteResponse = function(response, destChanged) {

		checkout.smartCartEligible = response.smartCartEligible || 0;
		if ('serviceGroupRates' in response) {
			checkout.shippingServiceGroupRates = response.serviceGroupRates;
		}
		else if ('rates' in response) {
			checkout.shippingRates = response.rates;
		}

		if ('couriers' in response)
			checkout.shippingCouriers = response.couriers;

		if ('services' in response)
			checkout.shippingServices = response.services;

		if ('map' in response)
			checkout.shippingMapURL = response.map;

		if ('multiLocations' in response)
			checkout.shippingMultiLocations = response.multiLocations;

		if ('shippingRatesDetails' in response) {
			checkout.shippingRatesDetails = response.shippingRatesDetails;
		}

		if ('invalidShippingRates' in response) {
			checkout.invalidShippingRates = response.invalidShippingRates;
		}

		var serviceGroupRate;
		var rate;

		if (
			destChanged
		) {
			checkout.session.set({
				'shippingServiceGroupSet': 0,
				'shippingServiceSet': 0
			});
		}

		if (Object.keys(checkout.shippingServiceGroupRates).length > 0) {

			if (
				checkout.session.get('shippingServiceGroupSet')
				&& checkout.session.get('shippingServiceGroupID') in checkout.shippingServiceGroupRates
			) {
				serviceGroupRate = checkout.shippingServiceGroupRates[checkout.session.get('shippingServiceGroupID')];
			} else {
				serviceGroupRate = shipping.getCheapestGroupRate();
            }

			if (serviceGroupRate.shippingServiceGroupID == 'ERROR') {
				shipping.error(serviceGroupRate.error);
				checkout.shippingServiceGroupID = false;
			} else {
				checkout.shippingServiceGroupID = serviceGroupRate.shippingServiceGroupID;
			}

			shipping.total = (parseFloat(serviceGroupRate.price) || 0);
			shipping.originalShippingRetail = (parseFloat(serviceGroupRate.originalShippingRetail) || 0);
			
		} else if (Object.keys(checkout.shippingRates).length > 0) {

			if (
				checkout.session.get('shippingServiceSet')
				&& checkout.session.get('shippingServiceCode') in checkout.shippingRates
			) {
				rate = checkout.shippingRates[checkout.session.get('shippingServiceCode')];
			} else {
				rate = shipping.getCheapestRate();
			}

			if (rate.shippingServiceCode == 'ERROR') {
				shipping.error(rate.error);
				checkout.shippingServiceCode = false;
			} else {
				checkout.shippingServiceCode = rate.shippingServiceCode;
			}

			shipping.total = (parseFloat(rate.cost) || 0);
			shipping.originalShippingRetail = (parseFloat(rate.originalShippingRetail) || 0);

		}
		
		if ('weight' in response) {
			shipping.$weight.html((parseFloat(response.weight) || 0).toFixed(2) + ' lbs.');
			shipping.$weightWrap.show();
		} else
			shipping.$weightWrap.hide();

		if (response.taxValue) {
			cart.totals.taxValue = response.taxValue;
		} else {
			cart.totals.taxValue = 0;
		}

		cart.totals.update('cart');
	}

	this.getCountryName = function() {
		return shipping.$country.find('option:selected').html();
	};

	this.getCheapestGroupRate = function() {
		var cheapest = false;

		for (var shippingServiceGroupID in checkout.shippingServiceGroupRates) {
			var groupRate = checkout.shippingServiceGroupRates[shippingServiceGroupID];

			if (shippingServiceGroupID == 'ERROR')
				continue;

            if (groupRate.internalOnly)
                continue;

			if (groupRate.inStorePickup)
				continue;

			if (
				!cheapest
				|| parseFloat(groupRate.price) < parseFloat(cheapest.price)
			)
				cheapest = groupRate;
		}

		if (cheapest)
			return cheapest;

		if ('ERROR' in checkout.shippingServiceGroupRates)
			return checkout.shippingServiceGroupRates.ERROR;

		for (var shippingServiceGroupID in checkout.shippingServiceGroupRates)
			return checkout.shippingServiceGroupRates[shippingServiceGroupID];

		return false;
	};

	this.getCheapestRate = function(shippingCourierCode) {
		var cheapest = false;

		for (var shippingServiceCode in checkout.shippingRates) {
			var rate = checkout.shippingRates[shippingServiceCode],
				service = checkout.shippingServices[shippingServiceCode];

			if (shippingServiceCode == 'ERROR') {
				continue;
			}

			if ('internalOnly' in service) {
				continue;
			}

			if ('inStorePickup' in service) {
				continue;
			}

			if (
				shippingCourierCode
				&& rate.shippingCourierCode != shippingCourierCode
			) {
				continue;
			}

			if (
				!cheapest
				|| parseFloat(rate.cost) < parseFloat(cheapest.cost)
			) {
				cheapest = rate;
			}
		}

		if (cheapest) {
			return cheapest;
		}

		if ('ERROR' in checkout.shippingRates) {
			return checkout.shippingRates.ERROR;
		}

		for (var shippingServiceCode in checkout.shippingRates) {
			return checkout.shippingRates[shippingServiceCode];
		}

		return false;
	};

    this.inStorePickupSelected = function() {
        var selectedServiceGroup = checkout.shippingServiceGroupRates[checkout.shippingServiceGroupID]

        if (
            selectedServiceGroup
            && selectedServiceGroup['inStorePickup']
        ) {
            return true;
        }

        return false;
    }

	this.disable = function($disabledMsg) {
		shipping.$disabledMsg = $disabledMsg;
		shipping.$wrap.find('input,select').attr('disabled', 'disabled');
		shipping.$disabledOverlays.show();
	};

	this.enable = function() {
		shipping.$disabledMsg = false;
		shipping.$wrap.find('input,select').removeAttr('disabled');
		shipping.$disabledOverlays.hide();
		shipping.error(false);
	};

	this.showErrors = function(errors) {
		var errorMsgs = [];

		for (var i in errors)
			errorMsgs.push(errors[i]);

		shipping.error(errorMsgs.join('<br />'));
	};

	this.error = function(msg) {
		if (msg) {
			shipping.errorMsg = msg;
			shipping.$errorMsg.html(msg);
			shipping.$error.show();
		} else {
			shipping.$error.hide();
			shipping.errorMsg = false;
			shipping.$errorMsg.html('');
		}
	};

	this.getValidateErrors = function() {
		var errors = [];

		if (!Object.keys(cart.items).length)
			errors.push({
				'msg' : 'Cart is Empty'
			});

		if (!shipping.country)
			errors.push({
				'field' : shipping.$country,
				'msg'   : 'Country is Required'
			});

		if (
			shipping.zipRequired
			&& !shipping.zip
		)
			errors.push({
				'field' : shipping.$zip,
				'msg'   : 'Postal / Zip Code is Required'
			});

		if (errors.length)
			return errors;

		if (
			!checkout.shippingServiceGroupID
			&& !checkout.shippingServiceCode
		) {
			errors.push({
				'msg' : (shipping.errorMsg || 'Shipping Quote Failed')
			});
		}

		return errors;
	}

	this.showValidateErrors = function(errors) {
		var errorMsgs = [];

		$.each(errors, function(i, error) {
			if (error.field)
				shipping.fieldError(error.field, error.msg);
			else
				errorMsgs.push(error.msg);
		});

		if (errorMsgs.length)
			shipping.showErrors(errorMsgs);

	}

	this.fieldError = function($field, errorMsg) {
		$field
			.addClass('field-error')
			.tooltip({
				'title': errorMsg,
				'html': true,
				'trigger': 'manual'
			})
			.tooltip('show');
	};

	this.removeFieldError = function($field) {
		$field
			.removeClass('field-error')
			.tooltip('dispose');
	};
};

